module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAErCAYAAAAId3mkAAAABmJLR0QAAAAAAAD5Q7t/AAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAB3RJTUUH4wQFExkIFeGpfQAAAEdJREFUaN7tyjERADAIBDDAv+evBVh7yZxOklqaOpBlWZZlWZZlWZZlWZZlWZZlWZZlWZZlWZZlWZZlWZZlWZZlWZZl+bP8AAdDBlL1osddAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/images/progress_clean.png
// module id = 2131
// module chunks = 1